import fixturesConfig from './fixtures.config';

const defaults = {
  ENV: 'dev',
  MOCKAPI: false,
  URL: 'https://dev.api.kliksekolah.com/api',
  URL_2: 'https://stage.staff.kliksekolah.com/api',
  URL_3: 'https://tax.kliksekolah.com/api',
  PAYMENT: 'https://dev.api.payment.kliksekolah.com',
  fixtures: fixturesConfig,
};

const setEnv = (envKey, value) => {
  defaults[envKey] = value;
  return defaults;
};

export default {
  setEnv,
  ENV: defaults.ENV,
  MOCKAPI: defaults.MOCKAPI,
  URL: defaults.URL,
  URL_2: defaults.URL_2,
  URL_3: defaults.URL_3,
  PAYMENT: defaults.PAYMENT,
  fixtures: defaults.fixtures,
  PASSWORD: defaults.password,
};

